import { compactCents, formatCompetenceShort } from "../../../utils/directorFormat";

const known = (value) => (Number.isSafeInteger(value) ? value : 0);

const percentOf = (value, maximum) => (
  value > 0 ? `${Math.max(2, Math.round((value * 100) / maximum))}%` : "0%"
);

const signedCompact = (value) => {
  if (!Number.isSafeInteger(value)) return "Indisponível";
  return value > 0 ? `+${compactCents(value)}` : compactCents(value);
};

// Barras CSS no padrão de FlowBars: entradas previstas contra contratado + planejado, mês a mês.
const CoverageBars = ({ months = [], ariaLabel = "Entradas previstas e compromissos por mês" }) => {
  const maximum = Math.max(1, ...months.map((month) => Math.max(
    known(month.receivableCents),
    known(month.committedCents) + known(month.plannedCents),
  )));
  return <div className="director-coverage">
    <ul className="director-coverage__legend" aria-hidden="true">
      <li><i data-tone="receivable" />Entradas previstas</li>
      <li><i data-tone="committed" />Contratado</li>
      <li><i data-tone="planned" />Planejado</li>
      <li><i data-tone="uncovered" />Mês descoberto</li>
    </ul>
    <div className="director-coverage__months" role="list" aria-label={ariaLabel}>
      {months.map((month) => {
        const receivable = known(month.receivableCents);
        const committed = known(month.committedCents);
        const planned = known(month.plannedCents);
        const commitments = committed + planned;
        const label = formatCompetenceShort(month.competence);
        const uncovered = month.uncovered === true || month.netCents < 0;
        const description = [
          label,
          `entradas previstas ${compactCents(month.receivableCents)}`,
          `contratado ${compactCents(month.committedCents)}`,
          `planejado ${compactCents(month.plannedCents)}`,
          `${uncovered ? "falta" : "sobra"} ${compactCents(month.netCents)}`,
        ].join("; ");
        return <div
          className="director-coverage__month"
          data-uncovered={uncovered ? "true" : "false"}
          key={month.competence}
          role="listitem"
          aria-label={description}
          title={description}
        >
          <strong className="director-coverage__net" data-tone={uncovered ? "pressure" : "positive"}>
            {signedCompact(month.netCents)}
          </strong>
          <div className="director-coverage__plot" aria-hidden="true">
            <i
              className="director-coverage__bar director-coverage__bar--receivable"
              style={{ "--bar-size": percentOf(receivable, maximum) }}
            />
            <span className="director-coverage__stack" style={{ "--bar-size": percentOf(commitments, maximum) }}>
              {planned > 0 && <i
                className="director-coverage__bar director-coverage__bar--planned"
                style={{ flexGrow: planned }}
              />}
              {committed > 0 && <i
                className="director-coverage__bar director-coverage__bar--committed"
                style={{ flexGrow: committed }}
              />}
            </span>
          </div>
          <small className="director-coverage__label">{label}</small>
        </div>;
      })}
    </div>
  </div>;
};

export default CoverageBars;
